import type { CustomTheme, FormEmbedLogo } from "./types.js";

const CF_IMAGES_ACCOUNT = "BnHJsWKV9YoxrzW3ngtRrw";

export function buildLogoUrl(entityId: string, width: number): string {
  return `https://imagedelivery.net/${CF_IMAGES_ACCOUNT}/${entityId}/w=${width * 2},fit=scale-down`;
}

const THEME_COLOR_KEYS = [
  "primary",
  "primary-foreground",
  "background",
  "foreground",
  "border",
  "input",
  "muted",
  "muted-foreground",
  "accent",
  "accent-foreground",
  "card",
  "card-foreground",
  "ring",
  "destructive",
  "warning",
] as const;

export function replaceLegalLinks(text: string): string {
  const links =
    '<a href="https://formvue.com/legals/privacy" target="_blank" rel="noopener" class="fv-consent-link">Privacy Policy</a>' +
    " and " +
    '<a href="https://formvue.com/legals/terms" target="_blank" rel="noopener" class="fv-consent-link">Terms of Service</a>';
  return text.replace("{{legalLinks}}", links);
}

export function applyLogo(
  container: HTMLElement,
  logo?: FormEmbedLogo,
  name?: string
): void {
  const logoEl = container.querySelector("[data-logo]");
  if (!logoEl) return;

  if (logo?.entityId) {
    const img = document.createElement("img");
    img.style.display = "block";
    img.style.maxHeight = "32px";
    img.style.width = "auto";
    img.style.objectFit = "contain";
    img.src = buildLogoUrl(logo.entityId, 120);
    img.alt = name ?? "";
    logoEl.innerHTML = "";
    logoEl.appendChild(img);
  } else {
    logoEl.innerHTML = "";
  }
}

export function applyTheme(
  container: HTMLElement,
  theme?: CustomTheme
): void {
  if (!theme) return;

  if (theme.colors) {
    for (const key of THEME_COLOR_KEYS) {
      const value = theme.colors[key];
      if (value) container.style.setProperty(`--fv-theme-${key}`, value);
    }
  }

  if (theme.radius) {
    container.style.setProperty("--fv-theme-radius", theme.radius);
  }

  if (theme.fontFamily) {
    container.style.setProperty(
      "--fv-theme-font",
      `'${theme.fontFamily}', system-ui, -apple-system, sans-serif`
    );

    const shadow = container.getRootNode() as ShadowRoot;
    if (shadow instanceof ShadowRoot) {
      const family = encodeURIComponent(theme.fontFamily);
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = `https://fonts.googleapis.com/css2?family=${family}:wght@400;500;600;700&display=swap`;
      shadow.prepend(link);
    }
  }
}
